<div style="text-align: center;">
  <!--<p-chart type="bar" [data]="basicDataMonths" [options]="horizontalOptionsMonths" height="{{height}}px"></p-chart> -->
</div>
